import queryString from "query-string";
import {
  GetCreatorUserList,
  GetDate,
  GetIdsList,
  GetImprestStateList,
  GetSortField,
  GetSortType,
  GetTextSearch,
  GetUseHasAppendix
} from "../../../../assets/convertUrlFilter";
import { CONTACT_DETAIL_REVIEW } from "../../../../constants/sectionTypes";
import {
  APPENDIX,
  CREATOR_USER_IDS,
  END_DATE,
  CONTACT_IDS,
  IMPREST_IDS,
  SORT_FIELD,
  SORT_TYPE,
  START_DATE,
  TEXT_SEARCH,
  FILE_TYPE,
  USER_IDS,
  TEAM_IDS,
  IMPREST_STATES_FOR_OTHER_REPORTS,
  IMPREST_STATES,
  ALL_IMPREST_STATES_ARRAY
} from "../../../../constants/filters";
import { FILE_TYPES } from "../../../../constants/file";

export default () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [END_DATE]: GetDate(filters[END_DATE]),
    [START_DATE]: GetDate(filters[START_DATE]),
    [IMPREST_IDS]: GetIdsList(filters[IMPREST_IDS]),
    [SORT_FIELD]: GetSortField(filters[SORT_FIELD], CONTACT_DETAIL_REVIEW),
    [SORT_TYPE]: GetSortType(filters[SORT_TYPE]),
    [TEXT_SEARCH]: GetTextSearch(filters[TEXT_SEARCH]),
    [CREATOR_USER_IDS]: GetCreatorUserList(filters[CREATOR_USER_IDS]),
    [CONTACT_IDS]: GetIdsList(filters[CONTACT_IDS]),
    [APPENDIX]: GetUseHasAppendix(filters[APPENDIX]),
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS]),
    [IMPREST_STATES_FOR_OTHER_REPORTS]: GetImprestStateList(
      filters[IMPREST_STATES],
      ALL_IMPREST_STATES_ARRAY
    )
  };
};
